
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.872 24.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_43967","data-name":"Group 43967","transform":"translate(-1669.564 -246.155)","fill":"none","stroke":"#5b5be7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_29811","data-name":"Path 29811","d":"M0 1.525A1.525 1.525 0 011.525 0h6.1a1.525 1.525 0 011.524 1.525v10.718a1.525 1.525 0 01-1.525 1.524h-6.1A1.525 1.525 0 010 12.243z","transform":"rotate(180 839.731 135.047)"}}),_c('path',{attrs:{"id":"Path_29813","data-name":"Path 29813","d":"M4.529 14.206a1.525 1.525 0 011.525-1.525h6.1a1.525 1.525 0 011.525 1.525v10.718a1.525 1.525 0 01-1.525 1.524h-6.1a1.525 1.525 0 01-1.525-1.524z","transform":"translate(1679.008 234.225)"}}),_c('path',{attrs:{"id":"Path_29810","data-name":"Path 29810","d":"M0 1.525A1.525 1.525 0 011.525 0h6.1a1.525 1.525 0 011.524 1.525V4.97a1.525 1.525 0 01-1.525 1.525h-6.1A1.525 1.525 0 010 4.97z","transform":"rotate(180 839.731 126.7)"}}),_c('path',{attrs:{"id":"Path_29812","data-name":"Path 29812","d":"M4.529 14.206a1.525 1.525 0 011.525-1.525h6.1a1.525 1.525 0 011.525 1.525v3.444a1.525 1.525 0 01-1.525 1.525h-6.1a1.525 1.525 0 01-1.525-1.525z","transform":"translate(1679.008 250.92)"}})])])
          )
        }
      }
    